export enum IconName {
    Default = '',
    Close = 'close',
    Rocket = 'rocket',
    Check = 'check',
    Exclamation = 'exclamation',
    CheckCircle = 'check_circle',
    Error = 'error',
    Cancel = 'cancel',
}

export enum IconFolder {
    Default = 'material-symbols',
    Material = 'material-symbols',
    ODS = 'ods'
}

export enum IconSize {
    Default = 'standard',
    XS = 'xs',
    Small = 'small',
    Standard = 'standard',
    Medium = 'medium',
    Large = 'large',
    XL = 'xl',
    XXL = '2xl',
    XXXL = '3xl'
}